var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"horizontal-page-menu"},[_c('el-menu',{attrs:{"mode":"horizontal"}},[_c('el-menu-item',{on:{"click":_vm.add}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" Добавить")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }